export enum WORKSPACE_TYPES {
  CUSTOM = "CUSTOM",
  TEMPLATE = "TEMPLATE",
}
